export default __webpack_public_path__ + "static/media/ralphpic.7ec85b89.jpg";